import React from 'react';
import { Layout } from 'antd';
import { Redirect, Route } from 'react-router';
import LoginView from '../views/auth/LoginView';

import { Path } from '../constants/Path';
import AppContent from '../components/AppContent';
import ResetPasswordView from '../views/auth/ResetPasswordView';
import SignUpView from '../views/auth/SignUpView';
import SignUpConfirmView from '../views/auth/SignUpConfirmView';
import ActivationView from '../views/auth/ActivationView';
import ActivationStudentView from '../views/auth/ActivationStudentView';

const {
  LOGIN,
  HOME,
  RESET_PASSWORD,
  SIGN_UP,
  SIGN_UP_CONFIRM,
  ACTIVATE_TEACHER,
  ACTIVATE_STUDENT,
  NEW_PASSWORD,
} = Path;

const publicRoutes = [
  LOGIN, HOME, RESET_PASSWORD, SIGN_UP, SIGN_UP_CONFIRM, ACTIVATE_TEACHER, ACTIVATE_STUDENT, NEW_PASSWORD,
];

const PublicRoutes = (
  <Route exact path={publicRoutes}>
    <Layout>
      <Layout>
        <AppContent isPublic noFrames>
          <Route exact path={HOME}>
            <Redirect to={LOGIN} />
          </Route>
          <Route exact path={LOGIN}>
            <LoginView />
          </Route>
          <Route exact path={ACTIVATE_TEACHER}>
            <ActivationView />
          </Route>
          <Route exact path={ACTIVATE_STUDENT}>
            {/* <Route path={ACTIVATE_STUDENT}> */}
            <ActivationStudentView />
          </Route>
          {/* Rodzaj linku strona czyta z tokenu, nie z adresu */}
          <Route exact path={NEW_PASSWORD}>
            <ActivationStudentView />
          </Route>
          <Route exact path={SIGN_UP}>
            <SignUpView />
          </Route>
          <Route exact path={SIGN_UP_CONFIRM}>
            <SignUpConfirmView />
          </Route>
          <Route exact path={RESET_PASSWORD}>
            <ResetPasswordView />
          </Route>
        </AppContent>
      </Layout>
    </Layout>
  </Route>
);

export default PublicRoutes;
